import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PaymentFailedComponent } from './payment-failed.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { TranslatePmsLoader } from '@core/services/translate-pms-loader';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { TranslateResolver } from '@core/resolver/translate.resolver';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslatePmsLoader(http, ['SCREEN_PRECHECKIN_APP_PAGES'], environment.api.urlWording);
}

const routes: Routes = [
  { 
    path: '', 
    resolve: {translate: TranslateResolver},
    component: PaymentFailedComponent 
  }
];

@NgModule({
  declarations: [
    PaymentFailedComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      extend: true
    }),
    SharedModule,
  ],
  providers: [TranslateResolver]
})
export class PaymentFailedModule { }
